You will not be logged out and redirected to login again.
